import {MOBILE_BREAKPOINT} from './constants';
import Button from '@planday-corp/ui/actions/Button';
import TextField from '@planday-corp/ui/forms/fields/TextField';
import Text from '@planday-corp/ui/text/Text';
import styled from 'styled-components';

export const StyledFlexContainer = styled.div`
  display: flex;
`;

export const StyledContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

export const StyledForm = styled.form`
  width: calc(100% + 2rem);
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    gap: 0;
  }
  > * {
    flex-shrink: 0;
  }
`;

export const StyledTextField = styled(TextField)`
  flex: 1;
`;

export const WideButton = styled(Button)`
  width: 100%;
`;

export const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
`;

export const FlexStartText = styled(Text)`
  align-self: flex-start;
`;
